import React from "react";

import { StarRatingProps } from "./StarRating.d";

const StarRating = ({ value = 0, onChange, readOnly = false }: StarRatingProps) => {
  return (
    <div className="d-flex gap-1">
      {Array.from({ length: 5 }, (_, index) => {
        const _star = index + 1;
        return (
          <span
            key={_star}
            className={`${!readOnly ? "clickable" : ""} ${_star <= value ? "text-warning" : "text-muted"}`}
            onClick={() => {
              if (!readOnly && onChange) onChange(_star);
            }}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;
